import LoyaltyEarlyAccessSaleBanner from "../../components/LoyaltyEarlyAccessSale/Banner";
import addLoyaltyBanner from "../../helpers/addLoyaltyBanner";

const addLoyaltyEarlyAccessSaleBanner = ({
  viewportCategory,
  positionFinder,
  items,
}) =>
  addLoyaltyBanner({
    viewportCategory,
    positionFinder,
    items,
    BannerComponent: (
      <LoyaltyEarlyAccessSaleBanner key="loyaltyEarlyAccessSaleBanner" />
    ),
  });

export default addLoyaltyEarlyAccessSaleBanner;
